import { render, staticRenderFns } from "./ModalResetPassCode.vue?vue&type=template&id=289ad466&scoped=true&"
import script from "./ModalResetPassCode.vue?vue&type=script&lang=ts&"
export * from "./ModalResetPassCode.vue?vue&type=script&lang=ts&"
import style0 from "./ModalResetPassCode.vue?vue&type=style&index=0&id=289ad466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289ad466",
  null
  
)

export default component.exports